module.exports = __webpack_public_path__ + "static/media/terma.c6b61228.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/terma.png
// module id = 895
// module chunks = 0